module.exports = __webpack_public_path__ + "img/icon-socket.27818ce0.svg";